import { render, staticRenderFns } from "./AddCommentCard.vue?vue&type=template&id=0a402b85"
import script from "./AddCommentCard.vue?vue&type=script&lang=js"
export * from "./AddCommentCard.vue?vue&type=script&lang=js"
import style0 from "./AddCommentCard.vue?vue&type=style&index=0&id=0a402b85&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports